import {FETCH_TYPES, parseURL} from "../Connect";
import SystemConfig, {CONFIG_PARAMS, GAMECONF_PARAMS} from "../../system/SystemConfig";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";

@injectable()
class ConnectAjaxGetGameSessions extends AbstractConnect {

    public readonly fetchType: string = FETCH_TYPES.GET_GAME_SESSIONS;
    timeout: number = 20000;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
        @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {

        super(config, control, fetch, dom);

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).open_game_sessions > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).open_game_sessions * 1000;
        }
        this.setMethod(this.config.get(CONFIG_PARAMS.URL_GET_GAME_SESSIONS_METHOD));
    }

    async fetch(data) {
        if (data.playerId) {
            this.control.reset();
            this.data = data;

            return await this._fetch();
        }
        return true;
    }

    protected getParams(): Record<string, any> {
        return {
            sessionId: this.data.sessionId,
            serverApi: this.data.serverApi,
            player_id: this.data.playerId,
            game_id: this.data.gameId
        };
    }

    protected getUrl(): string {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_GET_GAME_SESSIONS), {
            "server_api": this.data.serverApi,
            "player_id": this.data.playerId,
            "casino_id": this.data.casinoId,
            "game_id": this.data.gameId
        });
    };
}

export default ConnectAjaxGetGameSessions;